import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { styles, theme } from 'app/theme/index'
import { useVocabularyData } from 'app/utils/vocabulary'
import { Link } from 'gatsby'
import React, { memo } from 'react'

export interface Props {
  id?: string
  languageCode?: string
  languagePrefix?: string | null
  sort?: number
  target?: string
  title: string
  translable?: boolean
  url: string
}

export const MenuItem = memo(function MenuItem({
  languageCode,
  target,
  title,
  translable,
  url,
}: Props) {
  if (!title || !url) {
    return null
  }

  return target ? (
    <External href={url} target={target}>
      {translable ? useVocabularyData(title, languageCode || 'it-IT') : title}
    </External>
  ) : (
    <Anchor to={url}>
      {translable ? useVocabularyData(title, languageCode || 'it-IT') : title}
    </Anchor>
  )
})

const Style = css`
  ${styles.description}

  display: inline-block;
  color: ${theme.colors.variants.neutralLight1};
  line-height: 1.25rem;
  position: relative;
  &:after {
    content: '';
    width: 100%;
    height: 0.0625rem;
    background: ${theme.colors.variants.neutralLight1};
    pointer-events: none;
    position: absolute;
    bottom: 0;
    left: 0;
    transform: scaleX(0);
    transform-origin: right;
    transition: transform 0.8s cubic-bezier(0.24, 0.43, 0.15, 0.97);
  }
  &:hover {
    &:after {
      transform: scaleX(1);
      transform-origin: left;
    }
  }
  &.active {
    &:after {
      transform: scaleX(1);
      transform-origin: left;
    }
  }
`

const Anchor = styled(Link)`
  ${Style}
`

const External = styled.a`
  ${Style}
`
